// components/Footer.js
import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Circle } from 'lucide-react';

const Footer = () => {
  const navigate = useNavigate();
  const clickCount = useRef(0);
  const resetTimer = useRef(null);
  const [pulse, setPulse] = useState(false);

  const handleSecretClick = () => {
    clickCount.current += 1;
    setPulse(true);
    setTimeout(() => setPulse(false), 150);

    // reset the counter if the clicks aren't quick enough
    if (resetTimer.current) clearTimeout(resetTimer.current);
    resetTimer.current = setTimeout(() => {
      clickCount.current = 0;
    }, 1500);

    if (clickCount.current >= 5) {
      clickCount.current = 0;
      navigate('/packages');
    }
  };

  return (
    <footer className="bg-[var(--z-ink)] text-white/85 py-6 border-t-2 border-[var(--z-accent)]">
      <div className="container mx-auto px-4">

        {/* <div className="flex flex-wrap justify-between">
          <div className="w-full md:w-1/3 mb-6 md:mb-0">
            <h3 className="text-xl font-semibold mb-4">Zabra Solutions</h3>
            <p>Providing innovative solutions since 2013</p>
          </div>
          <div className="w-full md:w-1/3 mb-6 md:mb-0">
            <h3 className="text-xl font-semibold mb-4">Quick Links</h3>
            <ul>
              <li><Link to="/privacy" className="hover:text-[#F29200]">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-[#F29200]">Terms of Service</Link></li>
            </ul>
          </div>
          <div className="w-full md:w-1/3">
            <h3 className="text-xl font-semibold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-[#F29200]">FB</a>
              <a href="#" className="hover:text-[#F29200]">TW</a>
              <a href="#" className="hover:text-[#F29200]">IN</a>
            </div>
          </div>
        </div> */}

        <div className="text-center flex items-center justify-center gap-2">
          <p>&copy; 2013 ZABRA SOLUTIONS. All rights reserved.</p>
          {/* Hidden trigger: click 5 times quickly to open the packages page */}
          <button
            onClick={handleSecretClick}
            aria-label="."
            className="opacity-30 hover:opacity-50 transition focus:outline-none"
          >
            <Circle
              size={10}
              className={`transition-transform ${pulse ? 'scale-150 text-[var(--z-accent)]' : 'text-gray-500'}`}
              fill="currentColor"
            />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;